export type SinglePrimitiveCriteria = string | number | Date

export type PrimitiveCriteria =
    | SinglePrimitiveCriteria
    | SinglePrimitiveCriteria[]
